module.exports = __webpack_public_path__ + "static/Roboto-Light-c6cdfded4630ba6d9a2dceb70aa4fe0f.ttf";